import type { RouteObject } from 'react-router-dom';

import { AuthorizedOutlet } from '@myphx-engineering/auth/client';

import routes from '../app-routes';

import ClaimHistoryRoute from './ClaimHistoryRoute';
import ClaimsRoute from './ClaimsRoute';

const claimsRoutes: RouteObject[] = [
    {
        path: routes.claims.root,
        element: <AuthorizedOutlet />,
        children: [
            {
                path: routes.claims.history,
                element: <ClaimHistoryRoute />,
            },
            {
                path: routes.claims.claimId,
                element: <ClaimsRoute />,
            },
        ],
    },
];

export default claimsRoutes;
